import { render, staticRenderFns } from "./issuable_stats.vue.js?vue&type=template&id=91cd914a&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_stats.vue?vue&type=template&id=91cd914a&vue3"
import script from "./issuable_stats.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_stats.vue?vue&type=script&lang=js&vue3"
export * from "./issuable_stats.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_stats.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports